// Use the same product identity and inclusion rules throughout checkout and purchase.
export function numberValue(value)
{
    const number = Number(String(value ?? '').replaceAll(',', ''));
    return Number.isFinite(number) ? number : 0;
}

const firstText = (...values) => values.map(value => String(value ?? '').trim()).find(Boolean) || '';

export function ecommerceItems(order = {})
{
    const items = Object.values(order.products || {}).flatMap(product => {
        // Never fall back to a basket/order row ID: it is not a catalogue ID.
        const id = firstText(product.st_code, product.item_id, product.ean_code);
        const name = firstText(product.item_name, product.description, id);
        if (!id) return [];
        const quantity = Math.trunc(numberValue(product.quantity));
        if (quantity <= 0) return [];
        return [{
            item_id: id,
            item_name: name,
            item_brand: product.brand || '',
            item_category: product.product_type && product.product_type !== 'product' ? 'Services' : (product.price_range || 'Tyres'),
            quantity,
            price: numberValue(product.retail),
            coupon: order.discount_codes || '',
            currency: 'GBP'
        }];
    });
    if (numberValue(order.mobile_fitting_amount) > 0 && !items.some(item => item.item_id === 'MOBILE_FITTING'))
    {
        items.push({item_id: 'MOBILE_FITTING', item_name: 'Mobile Fitting Service', item_category: 'Services', quantity: 1, price: numberValue(order.mobile_fitting_amount), currency: 'GBP'});
    }
    return items;
}
